var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{ref:"frame",staticClass:"email-html-frame",style:({height: _vm.height + 'px'}),attrs:{"srcdoc":_vm.srcdoc,"sandbox":"allow-same-origin allow-popups allow-popups-to-escape-sandbox","referrerpolicy":"no-referrer","title":"Contenido del email"},on:{"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }